import type {UseQueryOptions} from '@tanstack/react-query';

import {getQuoteItemsV2Cart, useGetQuoteItemsV2Cart} from 'api/magento/cart/cart';

/**
 * get quote items cart data
 */
export const useGetQuoteItemsCartData = (
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuoteItemsV2Cart>>>>,
) => {
    const {data, isLoading} = useGetQuoteItemsV2Cart('regular', {collectTax: false}, {query});

    return {data, isLoading};
};
